export default __webpack_public_path__ + "static/media/petri-dish-lb.9a89ea98.svg";